var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('notifications'),_c('side-bar',{attrs:{"logo":"172b4d"}},[_c('template',{slot:"links"},[(_vm.user.roles.creative_catalogue_access)?_c('sidebar-item',{attrs:{"link":{
        name: 'Collections',
        path: '/collections',
        icon: 'fa fa-images text-info',
      }}}):_vm._e(),(_vm.user.roles.archive_access)?_c('sidebar-item',{attrs:{"link":{
        name: 'Match Video',
        icon: 'ni ni-archive-2 text-danger',
      }}},[_c('sidebar-item',{attrs:{"link":{
          name: 'Matches',
          path: '/matches',
        }}}),(_vm.user.roles.archive_search)?_c('sidebar-item',{attrs:{"link":{
          name: 'Ready Clipped Moments',
          path: '/clips',
        }}}):_vm._e(),(_vm.user.roles.archive_search)?_c('sidebar-item',{attrs:{"link":{
          name: 'Clip Request Queue',
          path: '/clipping-requests',
        }}}):_vm._e(),(_vm.user.roles.archive_uploader)?_c('sidebar-item',{attrs:{"link":{
          name: 'Match Recordings Admin',
          path: '/admin',
        }}}):_vm._e(),(_vm.user.roles.archive_uploader)?_c('sidebar-item',{attrs:{"link":{
          name: 'Match ID Admin',
          path: '/data/matches',
        }}}):_vm._e(),(_vm.user.roles.archive_uploader)?_c('sidebar-item',{attrs:{"link":{
          name: 'Player ID Admin',
          path: '/data/players',
        }}}):_vm._e(),(_vm.user.roles.archive_uploader)?_c('sidebar-item',{attrs:{"link":{
          name: 'Competition ID Admin',
          path: '/data/competitions',
        }}}):_vm._e(),(_vm.user.roles.archive_uploader)?_c('sidebar-item',{attrs:{"link":{
          name: 'Recent Recordings',
          path: '/recent-recordings',
        }}}):_vm._e()],1):_vm._e(),(_vm.user.roles.livestream_access)?_c('sidebar-item',{attrs:{"link":{
        name: 'Livestreams',
        icon: 'ni ni-world-2 text-primary',
      }}},[(_vm.user.roles.livestream_admin)?_c('sidebar-item',{attrs:{"link":{
          name: 'Today\'s Dashboard',
          path: '/livestreams/dashboard',
        }}}):_vm._e(),_c('sidebar-item',{attrs:{"link":{
          name: 'Brightcove stream channels',
          path: '/livestreams/channels',
        }}}),(_vm.user.roles.livestream_admin)?_c('sidebar-item',{attrs:{"link":{
          name: 'Livestream Routing Admin',
          path: '/data/livestream-routing',
        }}}):_vm._e(),(_vm.user.roles.livestream_admin)?_c('sidebar-item',{attrs:{"link":{
          name: 'Stream Reporting',
          path: '/livestreams/stream-reporting',
        }}}):_vm._e(),(_vm.user.roles.livestream_admin)?_c('sidebar-item',{attrs:{"link":{
            name: 'Takers',
            path: '/livestreams/takers',
          }}}):_vm._e(),(_vm.user.roles.livestream_admin)?_c('sidebar-item',{attrs:{"link":{
            name: 'Inputs',
            path: '/livestreams/inputs',
          }}}):_vm._e()],1):_vm._e(),(_vm.user.roles.user_admin)?_c('sidebar-item',{attrs:{"link":{
        name: 'Admin',
        icon: 'ni ni-atom text-pink',
      }}},[_c('sidebar-item',{attrs:{"link":{
          name: 'Users',
          path: '/users',
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Companies',
          path: '/companies',
        }}})],1):_vm._e(),_c('sidebar-item',{staticClass:"last-item",attrs:{"link":{
        name: _vm.user.name,
        icon: 'ni ni-badge text-warning',
        path: '/user',
      }}})],1)],2),_c('div',{staticClass:"main-content"},[(!_vm.$route.meta.hideNav)?_c('dashboard-navbar'):_vm._e(),_c('div',{on:{"click":function($event){return _vm.$sidebar.displaySidebar(false)}}},[_c('fade-transition',{attrs:{"duration":200,"origin":"center top","mode":"out-in"}},[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }